import * as Joi from 'joi';
import {SchoolFormData} from '../../../models';
import {getJoiObject, getMasterCodeObjectDropdownSchema} from '../../../utils/JoiUtils';

const schoolSchema = Joi.object<SchoolFormData>({
  country: getJoiObject(getMasterCodeObjectDropdownSchema(false, 'Country'), false),
  dateOfAdmission: Joi.string().required().messages({
    'string.empty': 'Date of Admission is not allowed to be empty',
    'any.required': 'Date of Admission is not allowed to be empty',
  }),
  dateOfCompletion: Joi.string().required().messages({
    'string.empty': 'Date of Completion is not allowed to be empty',
    'any.required': 'Date of Completion is not allowed to be empty',
  }),
  highestLevelPassed: Joi.string().max(20).required().messages({
    'string.empty': 'Highest Level Passed is not allowed to be empty',
    'string.max': 'Highest Level Passed cannot be exceed more than 20 characters',
    'any.required': 'Highest Level Passed is required',
  }),
  schoolName: Joi.string().max(100).required().messages({
    'string.empty': 'Name of School Attending is not allowed to be empty',
    'string.max': 'Name of School Attending cannot be exceed more than 100 characters',
    'any.required': 'Name of School Attending is required',
  }),
  typeOfSchool: Joi.string().max(50).required().messages({
    'string.empty': 'Type of School is not allowed to be empty',
    'string.max': 'Type of School is cannot be exceed more than 50 characters',
    'any.required': 'Type of School is required',
  }),
});

export default schoolSchema;
